import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'

import Index from '@/components/Index'
import Dashboard from '@/components/Dashboard/Dashboard'
import Home from '@/components/Dashboard/Home'
import NotFound from '@/components/NotFound'
import NetworkError from '@/components/NetworkError'

import Settings from '@/components/Auth/Settings'

import PasswordReset from '@/components/Auth/PasswordReset'
import PasswordChange from '@/components/Auth/PasswordChange'
import PasswordVerify from '@/components/Auth/PasswordVerify'

import DistributorsTable from '@/components/Providers/DistributorsTable'
import SuppliersTable from '@/components/Providers/SuppliersTable'
import CreateProvider from '@/components/Providers/CreateProvider'
import ProviderView from '@/components/Providers/ProviderView'

import MenuItems from '@/components/MenuItems/MenuItems'
import CreateMenuItems from '@/components/MenuItems/CreateMenuItems'

import Logout from '@/components/Logout'

import Translations from '@/components/Translations/Translations'
import TranslationEdit from '@/components/Translations/TranslationEdit'

import Users from '@/components/Users/Users'
import UserEdit from '@/components/Users/EditUserForm'
import CreateUser from '@/components/Users/CreateUser'
import UserView from '@/components/Users/UserView'

import Rates from '@/components/Rates//Rates'
import RateForm from '@/components/Rates//RateForm'
import RateView from '@/components/Rates/RateView'

import Contents from '@/components/Contents/Contents'
import ContentForm from '@/components/Contents/ContentForm'
import ContentView from '@/components/Contents/ContentView'

import CustomerTypes from '@/components/CustomerTypes/CustomerTypes'
import CustomerTypesForm from '@/components/CustomerTypes/CustomerTypesForm'
import CustomerTypesView from '@/components/CustomerTypes/CustomerTypesView'

Vue.use(Router);

const router = new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index,
            props: true,
        },
        {
            path: '/reset-password',
            name: 'PasswordReset',
            component: PasswordReset
        },
        {
            path: '/change-password/:token',
            name: 'PasswordChange',
            component: PasswordChange
        },
        {
            path: '/verify-password',
            name: 'PasswordVerify',
            component: PasswordVerify
        },
        {
            path: '/dashboard',
            component: Dashboard,
            meta: { requiresAuth: true },
            children: [
                {
                    path: 'change-password',
                    name: 'DashPasswordChange',
                    component: PasswordChange,
                    meta: { requiresAuth: true },
                },
                {
                    path: '',
                    name: 'HomeDefault',
                    component: Home,
                    meta: { requiresAuth: true, requiresAdmin: true },
                    
                },
                {
                    path: 'home',
                    name: 'Home',
                    component: Home,
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: 'settings',
                    name: 'Settings',
                    component: Settings,
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: 'logout',
                    name: 'Logout',
                    component: Logout,
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                
                // constants
                
                // {
                //     path: 'constants',
                //     name: 'Constants',
                //     component: Constants,
                //     meta: { requiresAuth: true, requiresAdmin: true },
                // },
                // {
                //     path: 'constants/new',
                //     name: 'ConstantCreate',
                //     component: ConstantsForm,
                //     props: true,
                //     meta: { requiresAuth: true, requiresAdmin: true },
                //     beforeEnter: (to, from, next) => {
                //         if (Object.keys(from.params).length === 0) {
                //             next('/dashboard/constants');
                //         }
                        
                //         next();
                //     }
                // },
                // {
                //     path: 'constants/edit',
                //     name: 'ConstantEdit',
                //     component: ConstantsForm,
                //     props: true,
                //     meta: { requiresAuth: true, requiresAdmin: true },
                //     beforeEnter: (to, from, next) => {
                //         if (Object.keys(from.params).length === 0) {
                //             next('/dashboard/constants');
                //         }
                        
                //         next();
                //     }
                // },

                //contents

                {
                    path: 'contents',
                    name: 'Contents',
                    component: Contents,
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: 'content/:id',
                    name: 'SingleContent',
                    component: ContentView,
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: 'contents/new',
                    name: 'ContentCreate',
                    component: ContentForm,
                    props: true,
                    meta: { requiresAuth: true, requiresAdmin: true },
                    beforeEnter: (to, from, next) => {
                        if (Object.keys(from.params).length === 0) {
                            next('/dashboard/contents');
                        }
                        
                        next();
                    }
                },
                {
                    path: 'contents/edit',
                    name: 'ContentEdit',
                    component: ContentForm,
                    props: true,
                    meta: { requiresAuth: true, requiresAdmin: true },
                    beforeEnter: (to, from, next) => {
                        if (Object.keys(from.params).length === 0) {
                            next('/dashboard/contents');
                        }
                        
                        next();
                    }
                },

                //customer types

                {
                    path: 'customer-types',
                    name: 'CustomerTypes',
                    component: CustomerTypes,
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: 'customer-types/:id',
                    name: 'SingleCustomerTypes',
                    component: CustomerTypesView,
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: 'customer-types/new',
                    name: 'CustomerTypesCreate',
                    component: CustomerTypesForm,
                    props: true,
                    meta: { requiresAuth: true, requiresAdmin: true },
                    beforeEnter: (to, from, next) => {
                        if (!from.params.customerType) {
                            next('/dashboard/customer-types');
                        }
                        
                        next();
                    }
                },
                {
                    path: 'customer-types/edit',
                    name: 'CustomerTypesEdit',
                    component: CustomerTypesForm,
                    props: true,
                    meta: { requiresAuth: true, requiresAdmin: true },
                    beforeEnter: (to, from, next) => {
                        console.log('from', from);
                        
                        if (!from.params.customerType) {
                            next('/dashboard/customer-types');
                        }
                        
                        next();
                    }
                },
                
                
                // menu items

                {
                    path: 'menu_items',
                    name: 'MenuItems',
                    component: MenuItems,
                    meta: { requiresAuth: true, requiresAdmin: true }

                },
                {
                    path: 'menu_items/new',
                    name: 'MenuItemsCreate',
                    component: CreateMenuItems,
                    props: true,
                    meta: { requiresAuth: true, requiresAdmin: true },
                    beforeEnter: (to, from, next) => {
                        if (Object.keys(from.params).length === 0) {
                            next('/dashboard/menu_items');
                        }
                        
                        next();
                    }
                },
                {
                    path: 'menu_items/edit',
                    name: 'MenuItemsEdit',
                    component: CreateMenuItems,
                    props: true,
                    meta: { requiresAuth: true, requiresAdmin: true },
                    beforeEnter: (to, from, next) => {
                        if (Object.keys(from.params).length === 0) {
                            next('/dashboard/menu_items');
                        }
                        
                        next();
                    }
                },

                // providers

                {
                    path: 'distributors',
                    name: 'Distributors',
                    component: DistributorsTable,
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: 'suppliers',
                    name: 'Suppliers',
                    component: SuppliersTable,
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: 'provider/:id',
                    name: 'SingleProvider',
                    component: ProviderView,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'provider/new',
                    name: 'ProviderAdd',
                    component: CreateProvider,
                    props: true,
                    meta: { requiresAuth: true, requiresAdmin: true },
                    beforeEnter: (to, from, next) => {
                        if (Object.keys(from.params).length === 0) {
                            next(-1);
                        }
                        
                        next();
                    }
                },
                {
                    path: 'providers/edit',
                    name: 'ProviderEdit',
                    component: CreateProvider,
                    props: true,
                    meta: { requiresAuth: true },
                    // meta: { requiresAdmin: true },
                    beforeEnter: (to, from, next) => {
                        if (Object.keys(from.params).length === 0) {
                            next(-1);
                        }

                        next();
                    }
                },


                // rates

                {
                    path: 'rates',
                    name: 'Rates',
                    component: Rates,
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: 'rate/:id',
                    name: 'SingleRate',
                    component: RateView,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'distributor-rates/new',
                    name: 'DistributorRateCreate',
                    component: RateForm,
                    props: true,
                    meta: { requiresAuth: true },
                    beforeEnter: (to, from, next) => {
                        if (Object.keys(from.params).length === 0) {
                            next(from.path);
                        }
                        
                        next();
                    }
                },
                {
                    path: 'distributor-rates/edit',
                    name: 'DistributorRateEdit',
                    component: RateForm,
                    props: true,
                    meta: { requiresAuth: true },
                    beforeEnter: (to, from, next) => {
                        if (Object.keys(from.params).length === 0) {
                            next(from.path);
                        }
                        
                        next();
                    }
                },
                {
                    path: 'supplier-rates/new',
                    name: 'SupplierRateCreate',
                    component: RateForm,
                    props: true,
                    meta: { requiresAuth: true },
                    beforeEnter: (to, from, next) => {
                        if (Object.keys(from.params).length === 0) {
                            next(from.path);
                        }
                        
                        next();
                    }
                },
                {
                    path: 'supplier-rates/edit',
                    name: 'SupplierRateEdit',
                    component: RateForm,
                    props: true,
                    meta: { requiresAuth: true },
                    beforeEnter: (to, from, next) => {
                        if (Object.keys(from.params).length === 0) {
                            next(from.path);
                        }
                        
                        next();
                    }
                },
                // {
                //     path: 'rates/new',
                //     name: 'RateCreate',
                //     component: RateForm,
                //     props: true,
                //     meta: { requiresAdmin: false },
                //     beforeEnter: (to, from, next) => {
                //         if (Object.keys(from.params).length === 0) {
                //             next(from.path);
                //         }
                        
                //         next();
                //     }
                // },
                // {
                //     path: 'rates/edit',
                //     name: 'RateEdit',
                //     component: RateForm,
                //     props: true,
                //     meta: { requiresAdmin: true },
                //     beforeEnter: (to, from, next) => {
                //         if (Object.keys(from.params).length === 0) {
                //             next(from.path);
                //         }
                        
                //         next();
                //     }
                // },

                // translations

                {
                    path: 'translations',
                    name: 'Translations',
                    component: Translations,
                    // meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: 'translation/edit',
                    name: 'TranslationEdit',
                    component: TranslationEdit,
                    props: true,
                    // meta: { requiresAuth: true, requiresAdmin: true },
                    beforeEnter: (to, from, next) => {
                        if (Object.keys(from.params).length === 0) {
                            next('/dashboard/translations');
                        }
                        
                        next();
                    }
                },
                {
                    path: 'translation/new',
                    name: 'TranslationCreate',
                    component: TranslationEdit,
                    props: true,
                    // meta: { requiresAuth: true, requiresAdmin: true },
                    beforeEnter: (to, from, next) => {
                        if (Object.keys(from.params).length === 0) {
                            next('/dashboard/translations');
                        }
                        
                        next();
                    }
                },

                // users

                {
                    path: 'users',
                    name: 'Users',
                    component: Users,
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: 'user/:id',
                    name: 'SingleUser',
                    component: UserView,
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: 'profile',
                    name: 'Profile',
                    component: UserView,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'users/new',
                    name: 'UserAdd',
                    component: CreateUser,
                    props: true,
                    meta: { requiresAuth: true, requiresAdmin: true },
                    beforeEnter: (to, from, next) => {
                        if (Object.keys(from.params).length === 0) {
                            next('/dashboard/users');
                        }
                        
                        next();
                    }
                },
                {
                    path: 'users/edit',
                    name: 'UserEdit',
                    component: UserEdit,
                    props: true,
                    meta: { requiresAuth: true, requiresAdmin: true },
                    beforeEnter: (to, from, next) => {
                        if (Object.keys(from.params).length === 0) {
                            next('/dashboard/users');
                        }
                        
                        next();
                    }
                },
            ]
        },
        {
            path: '*',
            name: 'NotFound',
            component: NotFound
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAdmin) {
        const auth = localStorage.getItem('user')
        if (auth === 'provider') {
            next(from.path)
        } else {
            next()
        }
    } else {
        next()
    }
})

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth) {
        const auth = localStorage.getItem('authToken')
        if (!auth) {
            next('/')
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js